/**
 * V3: Desktop Navigation
 *
 * Makes the submenu appear when a parent link is focused and the user
 * presses [ENTER]
 *
 * CSS is stil used to show the submenu on hover, so this is just for a11y.
 *
 * @module modules/V3NavDesktop
 */


// Dependencies
// ============================================================================

import { $ } from '../common/utility/u-jquery-$';


// Vars
// ============================================================================

// Els
const $headerMain = $( '.v3-header' );
const $parents    = $( '[data-v3-desktopnav-parent]' );

// Classes
const subnavOpenCls = 'js-subnav-open'; // a11y, toggled on subnavs
const parentOpenCls = 'js-parent-open'; // a11y, toggled on their parents


// ƒs
// ============================================================================

/**
 * Core module init
 *
 * @return  {void}
 */
function _moduleInit()
{
	focusSubMenu();
}


/**
 * Toggles the submenu when various keyboard events happen
 *
 * @return  {void}
 */
function focusSubMenu()
{
	$parents.each( ( i, el ) =>
	{
		const $parent    = $( el );
		const targetID   = $parent.attr( 'data-v3-desktopnav-parent' );
		const $subnav    = $( `[data-v3-desktopnav-subnav-target="${targetID}"]` );
		const $links     = $( `[data-v3-desktopnav-subnav-link="${targetID}"]` );
		const $firstLink = $links.first();
		const $lastLink  = $links.last();

		// Parent: Keyboard actions
		$parent.on( 'keydown', ( ev ) =>
		{
			// Toggle submenu on [ENTER]
			if ( ev.key === 'Enter' )
			{
				toggleSubmenu( $subnav, $parent );
			}

			// Close submenu on [TAB] + [SHIFT]
			if ( ev.key === 'Tab' && ev.shiftKey )
			{
				closeSubmenu( $subnav, $parent );
			}
		});

		// Submenu: Close when first item uses [TAB] + [SHIFT]
		$firstLink.on( 'keydown', ( ev ) =>
		{
			if ( ev.key === 'Tab' && ev.shiftKey )
			{
				closeSubmenu( $subnav, $parent );
			}
		});

		// Submenu: Close when last item uses [TAB]
		$lastLink.on( 'keydown', ( ev ) =>
		{
			if ( ev.key === 'Tab' && !ev.shiftKey )
			{
				closeSubmenu( $subnav, $parent );
			}
		});
	});
}


/**
 * Toggles the submenu!
 *
 * @return  {void}
 */
function toggleSubmenu( $subnav, $parent )
{
	if ( $subnav.hasClass( subnavOpenCls ) )
	{
		// Was open, so close
		$parent.removeClass( parentOpenCls );
		$subnav.removeClass( subnavOpenCls );
		$subnav.attr( 'aria-expanded', false );
	}
	else
	{
		// Was closed, so open
		$parent.addClass( parentOpenCls );
		$subnav.addClass( subnavOpenCls );
		$subnav.attr( 'aria-expanded', true );
	}
}


/**
 * Closes the submenu!
 *
 * @return  {void}
 */
function closeSubmenu( $subnav, $parent )
{
	$parent.removeClass( parentOpenCls );
	$subnav.removeClass( subnavOpenCls );
	$subnav.attr( 'aria-expanded', false );
}


// Auto Init
// ============================================================================

$( document ).ready( () => _moduleInit() );
